export default __webpack_public_path__ + "static/apple-981559c93c15468abc4001e6769819c6.svg";